import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentMasteryTestFailureAttemptRateSummary = (props) => (
  <KpiSummary
    isLoading={props.isLoading}
    title="Failures over attempts"
    previousValue={props.previousValue}
    currentValue={props.currentValue}
    formatter={props.formatter}
  />
);

ContentMasteryTestFailureAttemptRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentMasteryTestFailureAttemptRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentMasteryTestFailureAttemptRateSummary;
